'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'door-closed';
var width = 448;
var height = 512;
var aliases = [128682];
var unicode = 'f52a';
var svgPathData = ['M32 64l0 384 384 0 0-384c0-35.3-28.7-64-64-64L96 0C60.7 0 32 28.7 32 64zM352 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z', 'M320 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 448z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDoorClosed = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;